import { reactive } from "vue";
import { ArrowDown } from "@element-plus/icons-vue";
import createParticles from "../utils/text-effect";
export default {
  name: "KilaKilaCover",
  components: {
    ArrowDown: ArrowDown
  },
  setup: function setup(props) {
    var coverStyle = reactive({
      background: "url(".concat(require("@/" + props.imgUrl), ")"),
      backgroundSize: "cover"
    });

    function scrollToContent() {
      var h = document.getElementsByClassName("cover")[0].scrollHeight;
      window.scrollTo({
        top: h,
        behavior: "smooth"
      });
    }

    return {
      coverStyle: coverStyle,
      scrollToContent: scrollToContent
    };
  },
  mounted: function mounted() {
    createParticles();
  },
  props: {
    imgUrl: {
      type: String,
      require: true
    },
    title: {
      type: String,
      require: true
    },
    content: {
      type: String,
      require: true
    }
  }
};